<template>

  <Form
    :title="$t('Account')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(account)">
      <div class="form-group">
        <label>{{ $t('Slug') }}</label>
        <div class="py-2">{{ account.slug }} (<router-link to="/config/slug">{{ $t('Edit') }}</router-link>)</div>
      </div>

      <hr>

      <div class="form-group">
        <label>{{ $t('Account name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="account.name">
        <ValidateMessage :error="validateErrors['name']" />
      </div>

      <div class="form-group">
        <label>Logo</label>
        <div class="mb-3">
          <Logo
            :src="account.logo_media_url" />
        </div>
        <InputOnePhoto
          v-model="account.logo_media_id"
          @input="setFile" />
        <ValidateMessage :error="validateErrors['logo_media_id']" />
      </div>
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import InputOnePhoto from '@/components/Fields/InputOnePhoto'
import Logo from '@/components/Parts/Logo'

export default {
  name: 'AccountProfile',
  components: {
    Form,
    InputOnePhoto,
    Logo
  },
  data () {
    const account = this.$store.getters.getAccount
    const {
      _id,
      name,
      slug,
      logo_media_id,
      logo_media_url
    } = account

    return {
      creating: false,
      loading: false,
      account: {
        _id,
        name,
        slug,
        logo_media_id,
        logo_media_url
      },
      validateErrors: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateCurrentAccount', data)
      .then((result) => {
        this.account = result
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setFile
    */
    setFile (media) {
      this.account.logo_media_url = media ? media.url : null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountProfile.vue